export interface ChartFieldMeta {
  field_id?: number
  type?: string
}

export interface ChartAdditional {
  departments?: Record<string, { id?: number; name?: string; parent_id?: number }>
}

export function resolveChartDisplayValue(
  value: unknown,
  fieldMeta?: ChartFieldMeta,
  additional?: ChartAdditional,
): unknown {
  if (fieldMeta?.type === 'department') {
    const department = additional?.departments?.[String(value)]
    return department?.name || value
  }

  if (fieldMeta?.type === 'departments' && Array.isArray(value)) {
    return value.map((item) => additional?.departments?.[String(item)]?.name || item).join(', ')
  }

  return value
}

export function resolveChartDisplayRow(
  row: Record<string, unknown>,
  fieldMeta?: Record<string, ChartFieldMeta>,
  additional?: ChartAdditional,
): Record<string, unknown> {
  const displayRow = { ...row }
  for (const key of Object.keys(fieldMeta || {})) {
    displayRow[key] = resolveChartDisplayValue(row[key], fieldMeta?.[key], additional)
  }
  return displayRow
}

export function chartColumnLabel(column: { Label?: string; Name?: string }): string {
  return column.Label || column.Name || ''
}
